export default __webpack_public_path__ + "static/media/welcome-tour-2-mob.a5952d5f.png";